export const DEFAULT = 16;